(() => {
  const selector = 'dialog[data-ck-quick-personalization]';
  const ready = new WeakSet();
  const initialized = new WeakSet();
  const triggers = new WeakMap();
  const setSkip = (dialog, skip) => {
    dialog.querySelector('[data-no-plate]').checked = skip;
    dialog.querySelectorAll('[required]').forEach(field => { field.disabled = skip; });
    dialog.querySelector('[data-skip-name]').disabled = !skip;
    dialog.querySelector('[data-skip-country]').disabled = !skip;
  };
  const initialize = dialog => {
    if (initialized.has(dialog)) return;
    initialized.add(dialog);
    const name = dialog.querySelector('input[type="text"]');
    const preview = dialog.querySelector('.ck-plate-preview__plate');
    const update = () => {
      const text = name.value.trim() || 'NOAH';
      const country = dialog.querySelector('input[type="radio"]:checked')?.value;
      dialog.querySelector('[data-preview-name]').textContent = text.toLocaleUpperCase();
      dialog.querySelector('[data-preview-country]').textContent = country === 'Duitsland' ? 'D' : country === 'België' ? 'B' : 'NL';
      preview.classList.toggle('ck-plate-preview__plate--be', country === 'België');
      preview.classList.toggle('ck-plate-preview__plate--de', country === 'Duitsland');
      preview.style.setProperty('--plate-name-size', Math.min(40, 290 / Math.max(text.length, 4)) + 'px');
    };
    const confirm = skip => {
      const form = dialog.closest('form');
      const button = triggers.get(dialog);
      if (!form || !button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      setSkip(dialog, skip);
      name.value = name.value.trim();
      const invalid = [...dialog.querySelectorAll('[required]:not(:disabled)')].find(field => !field.checkValidity());
      if (invalid) { invalid.reportValidity(); return; }
      dialog.close();
      ready.add(form);
      try { form.requestSubmit(button); } finally { ready.delete(form); }
    };
    name.addEventListener('input', update);
    dialog.querySelectorAll('input[type="radio"]').forEach(field => field.addEventListener('change', update));
    dialog.querySelector('.ck-personalization__confirm').addEventListener('click', () => confirm(false));
    dialog.querySelector('.ck-personalization__skip-link').addEventListener('click', () => confirm(true));
    dialog.querySelector('.ck-personalization__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    name.addEventListener('keydown', event => {
      if (event.key === 'Enter') { event.preventDefault(); confirm(false); }
    });
    update();
  };
  const intercept = event => {
    const button = event.type === 'click' ? event.target.closest?.('button[name="add"], input[type="submit"]') : event.submitter;
    const form = event.type === 'submit' ? event.target : button?.form;
    if (!form || ready.has(form)) return;
    const dialog = form.querySelector(selector);
    if (!dialog) return;
    const submit = button || form.querySelector('[type="submit"]');
    if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    initialize(dialog);
    triggers.set(dialog, submit);
    setSkip(dialog, false);
    if (!dialog.open) dialog.showModal();
  };
  window.addEventListener('click', intercept, true);
  window.addEventListener('submit', intercept, true);
})();
